module.exports = __webpack_public_path__ + "media/images/lb/054-265fa36683b0f3ebc8c19f988ab3874b.svg";